module.exports = __webpack_public_path__ + "static/media/image1.b98ab9c1.jpg";